<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-one">
<h1 style="line-height:2px; margin-bottom:0px;">Chapter One</h1>
<div class="section level2" id="the-pragmatics-of-religion-orthodoxy-and-self-expression">
<h2 style="font-family: Book Antiqua;  margin-top:0px;">The Pragmatics of Religion: Orthodoxy and Self-Expression</h2>
<br/><br/><br/>
<p><em>Neither a fixed abode nor a form that is thine alone nor any function peculiar to thyself have we given thee, Adam, to the end that according to thy longing and according to thy judgment thou mayest have and possess what abode, what form, and what functions thou thyself shalt desire. The nature of all other beings is limited and constrained within the bounds of laws prescribed by Us. Thou, constrained by no limits, in accordance with thine own free will…shall ordain for thyself the limits of thy nature.</em></p>
<p style="text-align: right;">—Pico Della Mirandola, <em>Oration</em> <em>on the Dignity of Man</em></p>
<br/>
<p>Rob: One of the arguments for religion has nothing to do with the existence of God, or even with Freud’s appraisal of the human condition. I know we’ll get to Freud later, James, but for now I want to ask you about an almost Darwinian argument. I don’t mean that we are going to discuss evolution in a biological way, but more as a metaphor for the development of religious tenets and institutions. Does that make sense?</p>
<p>James: Yes, let’s not get to Freud too soon, especially because we have this magnificent quotation from Pico della Mirandola. His brilliant examination of so much religious wisdom almost makes me want to say Darwin can stay on the shelf a little longer, too.</p>
<p>Rob: I understand. But for now, let’s focus on, shall we say, the ‘scientific’ wisdom in that quote. If we ignore his theological perspective and simply discuss humankind as a species with a wonderful and unique plasticity, not given by God, but just the result of the way things developed, I think we can make an argument that religious institutions will likewise evolve as a matter of course.</p>
<p>James: But Rob, are we then making Pico say something he didn’t really say? He does call the human, Adam. I’m not arguing for a biblical reading of his text. We know his tastes were extraordinarily ecumenical. Yet was it possible for him to arrive at such insight without the religious wisdom of the people he read (for example, the Chaldeans)? This uncovers a distinctly modern problem. People want the limitless Adam without the One who ordains the gift in the first place. Is it even possible to discuss this without deforming the human Pico describes?</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?6e55147e